import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { EmptyCard3 } from "@shadcn/pro-blocks/application/empty-sections/empty-section-4";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Languages, FileText, Info, User, MapPin, CreditCard } from "lucide-react";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";
import { checkSession } from "@features/auth";

export const Route = createFileRoute("/profile/")({
	beforeLoad: () => {
		document.title = 'bacehub | Startseite'
	},
	component: RouteComponent,
	loader: async () => {
		const sessionExists = await checkSession();

		if (!sessionExists) {
			throw redirect({
				to: "/",
			});
		}
	},
});

//https://www.figma.com/design/NBnn0MEdCHdbMj2LsWQqng/Consumer-App?node-id=121-6104&m=dev
export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];

	const settingsItems = [
		{
			icon: User,
			text: <T>{i18n.PROFILE_EDIT_PROFILE()}</T>,
			to: "/profile/edit-profile",
		},
		{
			icon: MapPin,
			text: <T>{i18n.PROFILE_LOCATIONS()}</T>,
			to: "/profile/locations",
		},
		{
			icon: Languages,
			text: <T>{i18n.PROFILE_CHANGE_APP_LANGUAGE()}</T>,
			to: "/profile/change-app-language",
			iconClassName: "text-foreground",
			iconContainerClassName: "md:border-foreground",
		},
		{
			icon: CreditCard,
			text: <T>{i18n.PROFILE_PAYMENT()}</T>,
			to: "/profile/payment",
		},
		{
			icon: FileText,
			text: <T>{i18n.PROFILE_PRIVACY_POLICY()}</T>,
			to: "https://bacehub.de/privacy-policy",
		},
		{
			icon: Info,
			text: <T>{i18n.PROFILE_IMPRINT()}</T>,
			to: "https://bacehub.de/Imprint",
		},
	];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="text-2xl font-breit px-6 py-4">
				<T>{i18n.PROFILE_MY_PROFILE()}</T>
			</h1>
			<div className="mx-6">
				{settingsItems.map((item, index) => (
					<EmptyCard3
						key={index}
						icon={item.icon}
						title={item.text}
						to={item.to}
						iconClassName={item.iconClassName}
						iconContainerClassName={item.iconContainerClassName}
					/>
				))}
			</div>
		</PageContainer>
	);
}
